import React from 'react';
import {Route, Routes} from 'react-router-dom';
import {Login} from '../../pages/Login';
import {Register} from '../../pages/Register';
import {ProtectedRoute} from './ProtectedRoute';
import {RouteNotFound} from '../../pages/RouteNotFound';
import {Welcome} from '../../pages/Welcome';
import {Agreement} from '../../pages/Agreement';
import {MyApplication} from '../../pages/MyApplication';
import {Leads} from '../../pages/Leads';
import {Applications} from '../../pages/Applications';
import {Application} from '../../pages/Application';
import {Packages} from '../../pages/Packages';
import {Stages} from '../../pages/Stages';
import {Navigate} from 'react-router-dom';
import {Users} from "../../pages/Users";

export const AppRoutes = () => {
    return (
        <Routes>
            <Route path="/" element={<Navigate to="/login" />} />

            <Route element={<ProtectedRoute scope="GUEST" />}>
                <Route path="login" element={<Login />} />
                <Route path="register" element={<Register />} />
            </Route>

            <Route element={<ProtectedRoute scope="CLIENT" />}>
                <Route path="/welcome" element={<Welcome />} />
                <Route path="/agreement" element={<Agreement />} />
                <Route path="/my-application" element={<MyApplication />} />
            </Route>

            <Route element={<ProtectedRoute scope="STAFF" />}>
                <Route path="/leads" element={<Leads />} />
                <Route path="/applications" element={<Applications />} />
                <Route path="/applications/:id" element={<Application />} />
                <Route path="/packages" element={<Packages />} />
                <Route path="/stages" element={<Stages />} />
            </Route>

            <Route element={<ProtectedRoute scope="ADMIN" />}>
                <Route path="/users" element={<Users />} />
            </Route>

            <Route path="*" element={<RouteNotFound/>} />
        </Routes>
    )
}
